import { jsx as _jsx } from "react/jsx-runtime";
import { AuditRow, colors } from "../ui/index.js";
export function SessionTimeline({ log }) {
    if (log.length === 0) {
        return (_jsx("p", { style: { margin: 0, color: colors.textSecondary, fontSize: "0.85rem" }, children: "No activity recorded yet." }));
    }
    // Render newest first.
    const sorted = [...log].sort((a, b) => (a.ts < b.ts ? 1 : -1));
    return (_jsx("div", { style: { display: "flex", flexDirection: "column" }, children: sorted.map((entry) => (_jsx(AuditRow, { entry: entry }, entry.id))) }));
}
